import axios from './config';

export const getUserDistributors = ({ queryStr, params }) => {
  return axios.get(`/user-distributors?${queryStr}`, { params }).then(res => res.data.data);
};
